import Home from "../../../components/Home/Home";
import {sidebarItems} from "../../../utils/sidebarItems";

const SupervisorHome = () => {
    return (
       <Home navigationItems={sidebarItems.supervisor}/>
    )
}

export default SupervisorHome;